import { SectionLayout } from "@mittwald/flow-components/dist/components/Section/components";
import type { FC } from "react";
import React from "react";
import type WebhostingArticle from "../../../model/article/WebhostingArticle";
import ConfigurationResourceSection from "../../../pages/app/project/modals/CreateProject/components/ConfigurationResourceSection";
import ConfigurationStorageSection from "../../../pages/app/project/modals/CreateProject/components/ConfigurationStorageSection";

interface Props {
  selectedWebhostingArticles: WebhostingArticle[];
  selectedArticle: WebhostingArticle;
}

export const ConfigurationSections: FC<Props> = (props) => {
  const { selectedArticle, selectedWebhostingArticles } = props;

  return (
    <SectionLayout>
      <ConfigurationResourceSection
        currentWebhostingArticle={selectedArticle}
        isInWidget
        isProSpaceProject={false}
        selectedWebhostingArticles={selectedWebhostingArticles}
      />
      <ConfigurationStorageSection
        isInWidget
        selectedArticle={selectedArticle}
      />
    </SectionLayout>
  );
};

export default ConfigurationSections;
